// extracted by mini-css-extract-plugin
export default {"fullScreenNav":"styles_full-screen-nav__WspKR"};